export const CHAT_TYPESET_CLASS = "typeset typeset-chat";
